module.exports = __webpack_public_path__ + "img/_0.aae0ddef.png";